// extracted by mini-css-extract-plugin
export default {"tasks":"bW-z","task":"cW-z","svg":"dW-z","text":"eW-z"};